// extracted by mini-css-extract-plugin
module.exports = {"actions":"SolutionEmployer_actions__HrNki","content":"SolutionEmployer_content__u3j_V","field":"SolutionEmployer_field__27Qqn","center":"SolutionEmployer_center__3jWDo"};